import {
    FETCH_LANG_CUSTOMER_SUCCESS,
} from '../constants/ActionTypes';

const initialState = {
    langCustomer: {
        newCustomer: "ลูกค้าใหม่",
        prospect: "ลูกค้าที่คาดหวัง",
        reEntry: "ลูกค้าที่กลับมาซื้อใหม่",
        target: "เป้า",
        activeCustomer: "Active Customer",
        inactive: "Inactive",
        customerBuyAndNot: "ลูกค้าที่ซื้อ / ไม่ซื้อ สินค้า",
        customerBuyAmount: "จำนวนลูกค้าที่ซื้อ",
        customerNotBuyAmount: "จำนวนลูกค้าที่ไม่ซื้อ",
        customerAllAmount: "จำนวนลูกค้าทั้งหมด",
        customerGroup: "กลุ่มลูกค้า",
        customerInfo: "ข้อมูลลูกค้า",
        customerBuyProduct: "ซื้อสินค้า",
        customerNotBuyProduct: "ไม่ซื้อสินค้า",
        customerName: "ชื่อลูกค้า",
        customerReceivableAging: "อายุลูกหนี้",
        customerReceivableAgingInfo: "ข้อมูลอายุลูกหนี้",
        customerReceivableAgingNotOver: "ไม่เกิน",
        customerReceivableAgingOver: "เกิน",
        customerReceivable: "ข้อมูลลูกหนี้",
        customerOverDue: "Over Due",
        customerDue: "Due",
        customerNotDue: "Not Due",
        customerCode: "รหัสลูกค้า",
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_LANG_CUSTOMER_SUCCESS:
            return {
                ...state,
                langCustomer: {
                    newCustomer: action.payload.newCustomer 
                        ? action.payload.newCustomer : initialState.langCustomer.newCustomer,
                    prospect: action.payload.prospect
                        ? action.payload.prospect : initialState.langCustomer.prospect,
                    reEntry: action.payload.reEntry
                        ? action.payload.reEntry : initialState.langCustomer.reEntry,
                    target: action.payload.target 
                        ? action.payload.target : initialState.langCustomer.target,
                    activeCustomer: action.payload.activeCustomer 
                        ? action.payload.activeCustomer : initialState.langCustomer.activeCustomer,
                    inactive: action.payload.inactive 
                        ? action.payload.inactive : initialState.langCustomer.inactive,
                    customerBuyAndNot: action.payload.customerBuyAndNot 
                        ? action.payload.customerBuyAndNot : initialState.langCustomer.customerBuyAndNot,
                    customerBuyAmount: action.payload.customerBuyAmount 
                        ? action.payload.customerBuyAmount : initialState.langCustomer.customerBuyAmount,
                    customerNotBuyAmount: action.payload.customerNotBuyAmount 
                        ? action.payload.customerNotBuyAmount : initialState.langCustomer.customerNotBuyAmount,
                    customerAllAmount: action.payload.customerAllAmount 
                        ? action.payload.customerAllAmount : initialState.langCustomer.customerAllAmount,
                    customerGroup: action.payload.customerGroup 
                        ? action.payload.customerGroup : initialState.langCustomer.customerGroup,
                    customerInfo: action.payload.customerInfo 
                        ? action.payload.customerInfo : initialState.langCustomer.customerInfo,
                    customerBuyProduct: action.payload.customerBuyProduct 
                        ? action.payload.customerBuyProduct : initialState.langCustomer.customerBuyProduct,
                    customerNotBuyProduct: action.payload.customerNotBuyProduct 
                        ? action.payload.customerNotBuyProduct : initialState.langCustomer.customerNotBuyProduct,
                    customerName: action.payload.customerName 
                        ? action.payload.customerName : initialState.langCustomer.customerName,
                    customerReceivableAging: action.payload.customerReceivableAging 
                        ? action.payload.customerReceivableAging : initialState.langCustomer.customerReceivableAging,
                    customerReceivableAgingInfo: action.payload.customerReceivableAgingInfo 
                        ? action.payload.customerReceivableAgingInfo : initialState.langCustomer.customerReceivableAgingInfo,
                    customerReceivableAgingNotOver: action.payload.customerReceivableAgingNotOver 
                        ? action.payload.customerReceivableAgingNotOver : initialState.langCustomer.customerReceivableAgingNotOver,
                    customerReceivableAgingOver: action.payload.customerReceivableAgingOver
                        ? action.payload.customerReceivableAgingOver : initialState.langCustomer.customerReceivableAgingOver,
                    customerReceivable: action.payload.customerReceivable 
                        ? action.payload.customerReceivable : initialState.langCustomer.customerReceivable,
                    customerOverDue: action.payload.customerOverDue 
                        ? action.payload.customerOverDue : initialState.langCustomer.customerOverDue,
                    customerDue: action.payload.customerDue 
                        ? action.payload.customerDue : initialState.langCustomer.customerDue,
                    customerNotDue: action.payload.customerNotDue 
                        ? action.payload.customerNotDue : initialState.langCustomer.customerNotDue,
                    customerCode: action.payload.customerCode 
                        ? action.payload.customerCode : initialState.langCustomer.customerCode,
                }
            }
        default:
            return state;
    }
}
